if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = '';
      let shippingSuccess = false

      // Bundle carts qualify on jars, not on cart value. A value threshold moves
      // with the subscription discount, so a subscriber fell short of it while a
      // one-time buyer with the same number of jars cleared it.
      const bundleJars = Number(this.getAttribute('data-bundle-jars')) || 0;
      const minJars = Number(this.getAttribute('data-free-shipping-min-jars')) || 0;

      // minJars being set at all means the Shopify rate behind this message is
      // the weight-based one, which does not read cart value AT ALL. So a cart
      // with no jars in it cannot be counted down in dollars -- there is no
      // amount that earns free shipping, and the old "$12 away" line was
      // promising something checkout would not honour. Eleven lotus bags is $66
      // and 715 g: over the money line, nowhere near the weight one.
      //
      // Silence rather than a corrected number, because there is no number to
      // correct it to. The threshold is 1447 g and this component only speaks
      // money. A jar cart still gets its nudge below; a snack cart gets no
      // promise instead of a false one.
      if ( minJars > 0 && bundleJars === 0 ) {
        this.innerHTML = '';
        return;
      }

      if ( bundleJars > 0 && minJars > 0 ) {
        if ( bundleJars >= minJars ) {
          shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
          shippingSuccess = true;
        } else {
          const short = minJars - bundleJars;
          // "packs", matching the builder. The cart and the builder count the
          // same things and have to call them the same thing -- a customer who
          // was told to add two more packs should not arrive here and be asked
          // for two more jars.
          shippingMessage = 'Add ' + short + ' more ' + (short === 1 ? 'pack' : 'packs') + ' for free shipping';
        }

        if ( this.hasAttribute('data-show-alert') ) {
          this.innerHTML = `
            <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
              ${shippingMessage}
            </div>`;
        } else {
          this.innerHTML = shippingMessage;
        }
        return;
      }

      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));

      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>`;
      } else {
        this.innerHTML = shippingMessage;
      }

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}